import { render } from "./NewsSources.vue?vue&type=template&id=664bb5d6&scoped=true"
import script from "./NewsSources.vue?vue&type=script&lang=js"
export * from "./NewsSources.vue?vue&type=script&lang=js"

import "./NewsSources.vue?vue&type=style&index=0&id=664bb5d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-664bb5d6"]])

export default __exports__